<template>
  <kt-panel-body>
    <div class="tab-content">

        <manage-access-filter :action="filterAction" ></manage-access-filter>
        <kt-datatable v-if="user" v-bind="datatableProps" ref="datatable"></kt-datatable>
      </div>
  </kt-panel-body>
 </template>

<script>
  import columns from './../../settlement/datatable/columns'
  import { ApiUrl } from '@/common/api.service'
  import { AuthorizationHeader } from '@/common/jwt.service'
  import actionsColumn from './../../settlement/datatable/actions'
  import { mapGetters } from 'vuex'
  import  manageAccessFilter  from './manage-access-filter'

  export default {
    components: {
      manageAccessFilter,
    },
    data(){
      return{
        query: {},
      }
    },
    computed: {
      ...mapGetters('user', ['user']),
      datatableProps() {
        return {
          withPanel: false,
          id: "settlement_datatable",
          data: {
            type: 'remote',
            source: {
              read: {
                url: ApiUrl.path('settlement/admin'),
                method: 'GET',
                headers: AuthorizationHeader,
                map: function(res) {
                  return res.data.data
                },
                params: {
                  query: this.query,
                   user_id: this.user.id
                },
              },
            },
            pageSize: 10,
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
          },
          layout: {
          },
          pagination: false,
          sortable: true,
          columns: columns,
          actions: actionsColumn
        }
      },
    },
    methods: {
      filterAction(e, query) {
        this.query = query
        if (this.$refs.datatable.KTDatatable) {
          this.$refs.datatable.reload()
        }
      },
    },
  }
</script>

<style>

</style>